const PULINABOTTI_USER_ID = '0';

const CREDIT_SHOP_DISPLAY_PATTERNS = [
  /^pulinabotti\s*\(\s*kredi/i,
  /^pulinabotti\s*\(\s*kredittikauppa/i,
];

export function isPulinabottiUserId(fromUserId) {
  if (fromUserId == null) return false;
  return String(fromUserId).replace(/n$/, '') === PULINABOTTI_USER_ID;
}

export function isPulinabottiAuthorName(name) {
  return (name || '').trim().toLowerCase() === 'pulinabotti';
}

export function isCreditShopBotDisplayName(fromDisplayName) {
  const d = (fromDisplayName || '').trim();
  if (!d) return false;
  const lower = d.toLowerCase();
  if (lower === 'pulinabotti (kredittikauppa)' || lower === 'pulinabotti (krediittikauppa)') {
    return true;
  }
  return CREDIT_SHOP_DISPLAY_PATTERNS.some((p) => p.test(d));
}

/**
 * Localized DM/inbox sender label for pulinabotti and credit-shop system senders.
 * Uses the viewer's UI locale (synced from user_settings.ui_locale when logged in).
 */
export function formatBotSenderDisplayName(
  { senderKind, fromUserId, fromDisplayName, fromUsername, authorName },
  t,
) {
  const kind =
    senderKind ||
    (isCreditShopBotDisplayName(fromDisplayName)
      ? 'credit_shop'
      : isPulinabottiUserId(fromUserId) ||
          isPulinabottiAuthorName(fromDisplayName) ||
          isPulinabottiAuthorName(fromUsername) ||
          isPulinabottiAuthorName(authorName)
        ? 'pulinabotti'
        : null);

  if (kind === 'credit_shop') {
    return `${t('bot.senderName')} (${t('bot.creditStore')})`;
  }
  if (kind === 'pulinabotti') {
    return t('bot.senderName');
  }
  return fromDisplayName || fromUsername || authorName || '—';
}
